module.exports = __webpack_public_path__ + "img/new_coupon_banner_br@2x.24899fe4.png";